<template>
  <v-card class="dash-card">
    <v-card-title class="dash-title" :style="'background: ' + (cardValues['color'] ? cardValues['color'] : '#00acc2')">
      <h2 class="dash-title-text">{{this.cardValues['id_text']}}</h2>
      <v-spacer></v-spacer>
      <div class="dash-title-text" v-if="pagination['total'] > qtdItens">
        <v-btn flat icon :disabled="pagination['total'] === 0 || pagination['current_page'] === 1" @click="getItems(pagination['current_page'] - 1)" color="white" style="margin: 0;">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <strong v-if="pagination['total'] === 0">0 - 0 de 0</strong>
        <strong v-else>{{this.pagination['from']}} - {{this.pagination['to']}} de {{this.pagination['total']}}</strong>
        <v-btn flat icon :disabled="pagination['current_page'] === pagination['last_page']" @click="getItems(pagination['current_page'] + 1)" color="white" style="margin: 0;">
          <v-icon>arrow_forward</v-icon>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn slot="activator" class="dash-title-btn" flat icon @click="$emit('filtersItem', cardValues['i'])" :disabled="!checkPermission('dashboard_custom', 'manage')">
          <v-badge left bottom :value="qtdFilters > 0" class="dash_badge" :color="cardValues['color'] ? cardValues['color'] : '#00acc2'">
            <template v-slot:badge>
              <span>{{qtdFilters}}</span>
            </template>
            <v-icon color="white">filter_list</v-icon>
          </v-badge>
        </v-btn>
        <span>{{checkPermission('dashboard_custom', 'manage') ? 'Filtrar' : 'Sem permissão para filtrar'}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" class="dash-title-btn" :disabled="!checkPermission('dashboard_custom', 'edit')" flat icon @click="$emit('editItem', cardValues['i'])">
          <v-icon color="white">edit</v-icon>
        </v-btn>
        <span>{{checkPermission('dashboard_custom', 'edit') ? 'Editar' : 'Sem permissão para editar'}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" class="dash-title-btn" :disabled="!checkPermission('dashboard_custom', 'delete')" flat icon @click="$emit('deleteItem', cardValues['i'])">
          <v-icon color="white">close</v-icon>
        </v-btn>
        <span>{{checkPermission('dashboard_custom', 'delete') ? 'Excluir' : 'Sem permissão para excluir'}}</span>
      </v-tooltip>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="padding: 0px;width: 100%;height: 85%;">
      <v-layout v-if="loading" align-center justify-center row fill-height>
        <img :src="`${basePath}images/loader.gif`" width="100px" />
      </v-layout>
      <div v-else id="chart" style="width: 100%; height: 100%;">
        <apexchart :type="cardValues['card_type'] === 2 ? 'bar' : 'pie'" height="100%" :options="chartOptions" :series="series"></apexchart>
      </div>
    </v-card-text>
    <!-- <v-divider></v-divider> -->
    <!-- <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="processSave">Salvar</v-btn>
      <v-btn class="mx-0" :loading="loading" @click.native="closeDialogCreate()">Cancelar</v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<style scoped>
  .dash-card {
    /* border: 3px solid #00acc2; */
    border-radius: 13px;
    width: 100%;
    height: 100%;
  }
  .dash-title {
    padding: 0px;
    height: 45px;
  }
  .dash-title-text {
    padding-left: 20px;
    color: #fff;
    margin-bottom: 16px;
  }
  .dash-title-btn {
    margin-bottom: 20px;
  }
</style>

<script>
  /* eslint-disable eqeqeq, block-spacing, no-unneeded-ternary */
  import VueApexCharts from 'vue-apexcharts'
  import access from '../../../mixin/access'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  momentDurationFormatSetup(moment)

  export default {
    components: {apexchart: VueApexCharts},
    mixins: [access],

    props: {
      cardValues: {
        type: Object,
        default: () => { return {} }
      },
      dashboardId: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      pagination: {total: 0},
      qtdItens: 20,
      qtdFilters: 0,
      headers: [],
      loading: false,
      basePath: process.env.API,
      series: [],
      chartOptions: {}
    }),
    created () {
      this.getItems()
    },
    methods: {
      reloadItems (loading = true) {
        this.getItems(this.pagination['current_page'], loading)
      },
      getItems (page = 1, loading = true) {
        let selectedBoard = this.$store.getters[`selectedBoard/values`]
        let params = {
          taskBoardId: selectedBoard['id'],
          dashboardId: this.dashboardId,
          cardI: this.cardValues['i'],
          // perPage 25 para ter no maximo 25 registros e não deixar nada lento
          perPage: this.qtdItens,
          page: page
          // search: this.search,
        }
        // caso já esteja sendo carregado os dados, não carrega novamente
        if (this.loading === false) {
          if (loading) this.loading = true
          this.$http.post(`api/get_filtered_tasks`, params).then(res => {
            // this.getHeaders()
            this.getQtdFilters()
            // volta os campos para os valores inciais para não ficar lixo
            this.series = [{name: 'Valor', data: []}]
            // O layout da legenda da pizza esta sendo alterado direto do css no in.vue
            this.chartOptions = {
              xaxis: {categories: [], labels: {formatter: (val) => val, style: {fontSize: '15px'}}},
              yaxis: {labels: {formatter: (val) => val, style: {fontSize: '15px'}}},
              labels: [],
              dataLabels: {formatter: (val) => val, style: {fontSize: '15px', colors: ['#000000']}}
            }
            // Coloca os valores que aparecem na legenda
            this.chartOptions['labels'] = res.body.data.map(a => a[this.cardValues['grouping_fields']['value']] ? this.getItemValue(a[this.cardValues['grouping_fields']['value']], this.cardValues['grouping_fields']['type']) : '.Vazio.')
            // formata os valores da esquerda na barra e os valores da legenda na pizza de acordo com o tipo
            this.chartOptions['yaxis']['labels']['formatter'] = (value) => { return this.getItemValue(value, this.cardValues['fields']['type']) }
            if (this.cardValues['card_type'] === 2) {
              this.series = [{ name: 'Valor', data: res.body.data.map(a => (this.cardValues['fields']['type'] === 'value' && a[this.cardValues['fields']['value']]) ? a[this.cardValues['fields']['value']].toFixed(2) : a[this.cardValues['fields']['value']]) }]
              // Colocar o formato nos valores que mostra em cada barra
              this.chartOptions['dataLabels']['formatter'] = (value) => { return this.getItemValue(value, this.cardValues['fields']['type']) }
            } else if (this.cardValues['card_type'] === 3) {
              // Arredonda a porcentagem e insere o %, pq na pizza sempre vem já em porcentagem porem com muitas casas decimais
              this.chartOptions['dataLabels']['formatter'] = (value) => { return Math.round(value) + '%' }
              // Insere os itens que vão aparecer na pizza
              this.series = res.body.data.map((a) => {
                return a[this.cardValues['fields']['value']] ? (parseFloat(parseFloat(a[this.cardValues['fields']['value']]).toFixed(2))) : 0
              })
              // verifica se tem o campo de cor, se tiver inclui ele.
              if (res.body.data.length > 0 && res.body.data[0].hasOwnProperty('color')) {
                this.chartOptions['colors'] = res.body.data.map(a => a['color'])
              }
            }
            this.pagination = {
              total: res.body.total,
              per_page: res.body.per_page,
              current_page: res.body.current_page,
              last_page: res.body.last_page,
              from: res.body.from,
              to: res.body.to
            }
            this.loading = false
          }, err => {
            console.log(err)
            this.loading = false
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível carregar os dados. Reporte o erro.',
              color: 'error',
              dialog: true
            })
          })
        }
      },
      getItemValue (value, type) {
        let result = ''
        switch (type) {
          case 'value':
            result = value ? parseFloat(value) : 0
            result = result.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})
            break
          case 'number':
            result = value ? value : 0
            break
          case 'time':
            // caso não tenha dados, deve colocar 0 pois nos graficos se for outro tipo sem ser inteiro no campos de valor, da problema
            result = (value > 0) ? moment.duration(parseInt(value), 'seconds').format('hh:mm:ss', {trim: false}) : 0
            break
          default:
            // limita a 25 caracteres para que as legendas não fiquem muito grandes
            result = value ? (value.length > 25 ? value.slice(0, 25) + '...' : value) : ''
        }
        return result
      },
      // Função para pegar a quantidade de filtros existentes para colocor no badge do icone de filtro
      getQtdFilters () {
        this.qtdFilters = 0
        let filters = this.cardValues['filters']
        for (var prop in filters) {
          // caso a propriedade não seja vazia adiciona 1
          if (!(filters[prop] == '' || filters[prop] == [])) this.qtdFilters++
        }
      }
      // getHeaders () {
      // this.headers = []
      // this.cardValues['fields'].forEach(field => {
      //   this.headers.push({text: field['text'], value: field['value']})
      // })
      // }
    }
    // computed: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboardCustom/cards/CardChart.vue